import BackButton from 'Components/BackButton'
import Breadcrumbs from 'Components/Breadcrumbs'
import PageTitle from 'Components/PageTitle'
import { WithLoader } from 'Components/WithLoader'
import RefundCodeForm from 'Services/ControlDataManagement/Features/RefundCode/Components/RefundCodeForm'
import { SELECTED_REFUND_CODE_PARAMETER_KEY } from 'Services/ControlDataManagement/Features/RefundCode/Hooks/useRefundCodesWithParams'
import {
  useGetSingleRefundCodeQuery,
  useUpdateSingleRefundCodeMutation
} from 'Services/ControlDataManagement/Features/RefundCode/refundCodeApi'
import { usePreviousLocation } from 'Util/Context/previousLocationContext'
import { CONTROL_DATA_MANAGEMENT_ROOT_URL } from 'Util/constants'
import { Box, Grid } from '@mui/material'
import { useParams } from 'react-router-dom'
import { t } from 'ttag'

export default function RefundCodeEditPage() {
  const baseUrl = `${CONTROL_DATA_MANAGEMENT_ROOT_URL}/refund-codes`
  const { id } = useParams()
  const previousLocation = usePreviousLocation(
    `${baseUrl}?${SELECTED_REFUND_CODE_PARAMETER_KEY}=${id}`
  )
  const [, { isLoading: submitLoading }] = useUpdateSingleRefundCodeMutation()
  const { data: refundCode, isLoading } = useGetSingleRefundCodeQuery(id ?? '', {
    skip: !id
  })

  const breadcrumbs = [
    {
      title: t`Home`,
      link: CONTROL_DATA_MANAGEMENT_ROOT_URL
    },
    {
      title: t`Refund codes`,
      link: baseUrl
    },
    {
      title: t`Edit refund code`
    }
  ]

  return (
    <Box sx={{ width: '100%' }}>
      <Grid container spacing={2} mb={4}>
        <Grid size={12}>
          <Breadcrumbs items={breadcrumbs} />
          <BackButton label={t`Back`} link={previousLocation} />
          <PageTitle>{t`Edit refund code`}</PageTitle>
        </Grid>
      </Grid>
      <WithLoader loading={isLoading}>
        <RefundCodeForm
          refundCode={refundCode}
          successBaseUrl={previousLocation}
          submitLoading={submitLoading}
        />
      </WithLoader>
    </Box>
  )
}
